/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { Radio } from "antd";
import { radioButtonStyle } from "./styles";
import { IRadioButtonSelectProps } from "./interfaces";

export const RadioButtonSelect: React.FC<IRadioButtonSelectProps> = (
  props: IRadioButtonSelectProps
) => {
  const { value, onValueChange, defaultValue } = props;

  const renderRadioButtonComponent = () => {
    return (
      value &&
      value.map((data: any, key: number) => {
        return (
          <Radio.Button
            value={data.value}
            key={key}
            className="radio-button-override"
          >
            {data.label}
          </Radio.Button>
        );
      })
    );
  };
  return (
    <span css={radioButtonStyle}>
      <Radio.Group
        onChange={onValueChange}
        buttonStyle="solid"
        value={defaultValue}
      >
        {renderRadioButtonComponent()}
      </Radio.Group>
    </span>
  );
};
